import { ChangeEvent, useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import { useNavigate } from 'react-router-dom';
import { HidePassword, ShowPassword } from '../../../assets/Icons';
import { Button, Container, Spacer } from '../../../components/atoms';
import { InputField } from '../../../components/atoms/InputField/InputField';
import { useMutationHook } from '../../../network/mutations/useMutationHook';
import { register } from '../../../network/services/auth';
import { validators } from '../../../utils/validator';
import { AuthContainer, InputCon, TogglePassword, extraStylesInput } from '../styles';

const INITIALSTATE = {
  email: '',
  password: ''
};

const ForgotPassword = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [formData, setFormData] = useState(INITIALSTATE);

  const navigate = useNavigate();

  const [formError, setFormError] = useState(INITIALSTATE);

  const onUpdateFormData = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    const error = validators[name](value);
    setFormData(formData => ({ ...formData, [name]: value }));
    setFormError({
      ...formError,
      [name]: error
    });
  };

  const [showPassword, setShowPassword] = useState<'text' | 'password'>('password');

  const onTogglePassword = () => {
    if (showPassword === 'text') return setShowPassword('password');
    setShowPassword('text');
  };

  const { isLoading } = useMutationHook(register, 'SIGNUP');

  const _register = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    navigate('/admin/dashboard');
  };

  // const disabled = !formData.email || !formData.password || !!validators.email(formData.email);

  return (
    <AuthContainer>
      <div>
        <Spacer height="4rem" />

        <h1>Log in to your account</h1>
        <p className="option">
          Don't have an account? <span> Create an account</span>
        </p>

        <Container>
          <form className="sign-up">
            <Spacer height="1.5rem" />
            <InputCon>
              <span>Email Address</span>
              <InputField
                type="email"
                name="email"
                onChange={onUpdateFormData}
                placeholder="example@mail.com"
                extraStyles={extraStylesInput}
                required={true}
                error={formError.email}
                autoComplete="username"
              />
            </InputCon>

            <Spacer height="1.5rem" />
            <InputCon>
              <span>Password</span>
              <InputField
                type={showPassword}
                name="password"
                onChange={onUpdateFormData}
                placeholder="enter your password"
                extraStyles={extraStylesInput}
                // required={true}
                error={formError.password}
                action={
                  <TogglePassword onClick={onTogglePassword}>
                    {showPassword !== 'text' ? <ShowPassword /> : <HidePassword />}
                  </TogglePassword>
                }
                autoComplete="new-passowrd"
              />
            </InputCon>

            <Spacer height="2rem" />

            <a href="/#" className="forgot">
              Forgot Password?
            </a>

            <Spacer height="2rem" />

            <div className="buttonContainer">
              <Button isLoading={isLoading} type="submit" onClick={_register}>
                LOGIN
              </Button>
            </div>
          </form>
        </Container>
      </div>
    </AuthContainer>
  );
};

export default ForgotPassword;
